import React, { useState } from 'react';
import { FlexSpacer } from 'ui/flexSpacer/FlexSpacer';
import { Body2Bold, Body2 } from 'ui/theme/typography/components';
import { SegmentedControl } from 'ui/segmentedControl/SegmentedControl';
import { Container } from 'ui/container/Container';
import { SEGMENTED_CONTROL_SIZES } from 'ui/segmentedControl/types';
import { StyledIframeFullDoc } from './MessagePreview.styled';

const options = {
  html: {
    name: 'HTML',
    value: 'html',
  },
  plainText: {
    name: 'Plain text',
    value: 'plain-text',
  },
};

type Props = {
  html: string;
  plainText: string;
  subject: React.ReactNode;
  preheaderText?: React.ReactNode;
};

export const MessagePreview = ({ html = '', plainText = '', subject, preheaderText }: Props) => {
  const [selectedPreview, selectPreview] = useState(options.html.value);
  const onSelect = (value: string) => selectPreview(value);
  const srcDoc = selectedPreview === options.html.value ? html : plainText;

  return (
    <Container variant="primary" data-test="message-preview">
      <FlexSpacer flexDirection="column" alignItems="stretch" gap="actionGap">
        <FlexSpacer justifyContent="space-between" alignItems="baseline">
          <div>
            <Body2Bold>{subject}</Body2Bold>
            <Body2>{preheaderText}</Body2>
          </div>
          <SegmentedControl
            onSelect={onSelect}
            options={Object.values(options)}
            size={SEGMENTED_CONTROL_SIZES.LARGE}
            value={selectedPreview}
          />
        </FlexSpacer>
        <StyledIframeFullDoc isMaxHeightPref testId="message-preview-iframe">
          {srcDoc}
        </StyledIframeFullDoc>
      </FlexSpacer>
    </Container>
  );
};
